const READS_LOCALE = {
    
    buttons: {
        cancel: {
            en: "Cancel",
            fr: "Annuler",
        },
        download: {
            en: "Read",
            fr: "Lire",
        },
        listen: {
            en: "Listen",
            fr: "Écouter",
        },
        reset: {
            en: "Reset",
            fr: "Effacer",
        },
        show_more: {
            en: "Show More",
            fr: "Plus de détails"
        },
        submit: {
            en: "Submit",
            fr: "O.K.",
        }
    },
    
    book: {
        by: {
            en: "By",
            fr: "Par",
        },
        author: {
            en: "Author(s)",
            fr: "Auteur-e(s)",
        },
        citation: {
            en: "Citation",
            fr: "Citation",
        },
        copyright: {
            en: "Copyright",
            fr: "Copyright",
        },
        country: {
            en: "Country",
            fr: "Pays",
        },
        illustrator: {
            en: "Illustrator(s)",
            fr: "Illustrateur/trice(s)",
        },
        narrator: {
            en: "Narrator",
            fr: "Narrateur/trice",
        },
        nbpages: {
            en: "Number of pages",
            fr: "Nombre de pages",
        },
        nbPages: {
            en: "Number of pages",
            fr: "Nombre de pages",
        },
        noDescription: {
            en: "No description available.",
            fr: "Aucune description n'est disponible.",
        },
        nodescription: {
            en: "No description available.",
            fr: "Aucune description n'est disponible.",
        },
        publisher: {
            en: "Publisher",
            fr: "Maison de publication",
        },
        readinglevel: {
            en: "Reading Level",
            fr: "Niveau de lecture",
        },
        readingLevel: {
            en: "Reading Level",
            fr: "Niveau de lecture",
        },
        result: {
            en: "result",
            fr: "résultat",
        }  ,
        similar: {
            en: "Books you might like",
            fr: "Livres similaires",
        },
        suggestion: {
            en: "Books you might like",
            fr: "Livres similaires",
        },
        theme: {
            en: "Theme(s)",
            fr: "Thème(s)"
        },
        year: {
            en: "Year",
            fr: "Année",
        },
    },

    country: {
        australia: { en: "Australia", fr: "Australie" },
        canada: { en: "Canada", fr: "Canada" },
        china: { en: "China", fr: "Chine" },
        ethiopia: { en: "Ethiopia", fr: "Éthiopie" },
        france: { en: "France", fr: "France" },
        germany: { en: "Germany", fr: "Allemagne" },
        ghana: { en: "Ghana", fr: "Ghana" },
        greece: { en: "Greece", fr: "Grèce" },
        india: { en: "India", fr: "Indes" },
        iran: { en: "Iran", fr: "Iran" },
        kenya: { en: "Kenya", fr: "Kenya" },
        lesotho: { en: "Lesotho", fr: "Lesotho" },
        mozambique: { en: "Mozambique", fr: "Mozambique" },
        nigeria: { en: "Nigeria", fr: "Nigéria" },
        norway: { en: "Norway", fr: "Norvège" },
        russia: { en: "Russia", fr: "Russie" },
        "saudi arabia": { en: "Saudi Arabia", fr: "Arabie Saoudite" },
        "south africa": { en: "South Africa", fr: "Afrique du Sud" },
        "sri lanka": { en: "Sri Lanka", fr: "Sri Lanka" },
        tanzania: { en: "Tanzania", fr: "Tanzanie" },
        uganda: { en: "Uganda", fr: "Ouganda" },
        uk: { en: "UK", fr: "GB" },
        unknown: { en: "Unknown", fr: "Inconnu" },
        usa: { en: "USA", fr: "É-U" },
        yemen: { en: "Yemen", fr: "Yémen" },
    },

    credits: {
        authors: {
            en: "Authors",
            fr: "Auteur-es",
        },
        publishers: {
            en: "Publishers",
            fr: "Maison de publication",
        },
    },

    errors: {
        "404": {
            en: "Oops ... The page you were looking for does not exist.",
            fr: "Oops ... La page demandée n'existe pas."
        },
        no_books: {
            en: "No books found &#x2639",
            fr: "Aucun livre trouvé &#x2639",
        },
        no_book: {
            en: "Hmm, book not found.",
            fr: "Hmm, le livre est introuvable.",
        },
        no_book_description: {
            en: "Sorry, we could not find the requested book.",
            fr: "Désolé, nous ne pouvons pas trouvé le livre recherché.",
        },
        no_themes: {
            en: "Hmm ... this theme does not exist.",
            fr: "Hmm ... ce thème n'existe pas.",
        },
        no_themes_description: {
            en: "Sorry, maybe the theme you are looking has been removed or it simply does not exist.",
            fr: "Désolé, le thème a peut-être été modifié ou il n'existe tout simplement pas.",
        },
        no_suggestion: {
            en: "Hmm, there are no suggestions at this time.",
            fr: "Hmm, il n'y a aucune suggestion pour le moment."
        }
    },


    filters: {
        country: {
            en: "Country",
            fr: "Pays"
        },
        format: {
            en: "Format",
            fr: "Format",
        },
        language: {
            en: "Language",
            fr: "Langage",
        },
        level: {
            en: "Level",
            fr: "Niveau",
        },
        theme: {
            en: "Theme",
            fr: "Thème",
        },
        type: {
            en: "Type",
            fr: "Catégorie"
        },
    },

    footer: {
        credits: {
            en: "Credits",
            fr: "Crédits",
        },
        funders: {
            en: "Our Funders",
            fr: "Nos investisseurs",
        },
        team: {
            en: "Team",
            fr: "Notre équipe",
        },
    },

    formats: {
        audio: {
            en: "Audio", fr: "Audio"
        },
        html: {
            en: "HTML", fr: "HTML"
        },
        pdf: {
            en: "PDF", fr: "PDF"
        },
    },

    languages: {
        arabic: { en: "Arabic", fr: "Arabe"},
        chitonga: { en: "ChiTonga", fr: "ChiTonga" },
        english: { en: "English", fr: "Anglais" },
        lugbarati: { en: "Lugbarati", fr: "Lugbarati" },
        ekegusii: { en: "Ekegusii", fr: "Ekegusii"},
        oluwanga: { en: "Oluwanga", fr: "Oluwanga"},
        maa: { en: "Maa", fr: "Maa"},
        xhosa: { en: "Xhosa", fr: "Xhosa"},
        spanish: { en: "Spanish", fr: "Espagnol"},
        "ng'aturkana": { en: "Ng'aturkana", fr: "Ng'aturkana"},
        "ng&#039;aturkana": { en: "Ng'aturkana", fr: "Ng'aturkana"},
        lunyole: { en: "Lunyole", fr: "Lunyole"},
        setswana: { en: "Setswana", fr: "Setswana"},
        lumasaaba: { en: "Lumasaaba", fr: "Lumasaaba"},
        afrikaans: { en: "Afrikaans", fr: "Afrikaans"},
        isizulu: { en: "isiZulu", fr: "isiZulu"},
        naro: { en: "Naro", fr: "Naro"},
        kiswahili: { en: "Kiswahili", fr: "Kiswahili"},
        sabinyi: { en: "Sabinyi", fr: "Sabinyi" },
        hausa: { en: "Hausa", fr: "Hausa" },
        fulfulde: { en: "Fulfulde", fr: "Fulfulde" },
        kanuri: { en: "Kanuri", fr: "Kanuri" },
        zarma: { en: "Zarma", fr: "Zarma" },
        lugisu: { en: "Lugisu", fr: "Lugisu" },
        isixhosa: { en: "isiXhosa", fr: "isiXhosa" },
        lusoga: { en: "Lugosa", fr: "Lugosa" },
        sepedi: { en: "Sepedi", fr: "Sepedi" },
        sesotho: { en: "Sesotho", fr: "Sesotho" },
        isindebele: { en: "isiNdebele", fr: "isiNdebele" },
        ateso: { en: "Ateso", fr: "Ateso" },
        aringati: { en: "Aringati", fr: "Aringati" },
        olunyala: { en: "Olunyala", fr: "Olunyala" },
        french: { en: "French", fr: "Français" },
        yoruba: { en: "Yoruba", fr: "Yoruba" },
        chinese: { en: "Chinese", fr: "Chinois" },
        greek: { en: "Greek", fr: "Grec" },
        italian: { en: "Italian", fr: "Italien" },
        persian: { en: "Persian", fr: "Perse" },
        tshivenda: { en: "Tshivenda", fr: "Tshivenda" },
        xitsonga: { en: "Xitsonga", fr: "Xitsonga" },
        chiTonga: { en: "ChiTonga", fr: "ChiTonga" },
        chinyanja: { en: "Chinyanja", fr: "Chinyanja" },
        dhopadhola: { en: "Dhopadhola", fr: "Dhopadhola" },
        lugwere: { en: "Lugwere", fr: "Lugwere" },
        olukhayo: { en: "Olukhayo", fr: "Olukhayo" },
        kikamba: { en: "Kikamba", fr: "Kikamba" },
        luganda: { en: "Luganda", fr: "Luganda" },
        lusigu: { en: "Lusigu", fr: "Lusigu" },
        leblango: { en: "Leblango", fr: "Leblango" },
        portuguese: { en: "Portuguese", fr: "Portugais" },
        assamese: { en: "Assamese", fr: "Assamais" },
        kakwa: { en: "Kakwa", fr: "Kakwa" },
        gurene: { en: "Gurene", fr: "Gurene" },
        "afan oromo": { en: "Afan Oromo", fr: "Afan Oromo" },
        siswati: { en: "siSwati", fr: "siSwati" },
        rutooro: { en: "Rutooro", fr: "Rutooro" },
        lesotho: { en: "Lesotho", fr: "Lesotho" },
        "lámnso'": { en: "Lámnso'", fr: "Lámnso'" },
        amharic: { en: "Amharic", fr: "Amharic" },
        odia: { en: "Odia", fr: "Odia" },
        tamil: { en: "Tamil", fr: "Tamil" },
        telugu: { en: "Telugu", fr: "Telugu" },
        kannada: { en: "Kannada", fr: "Kannada" },
        german: { en: "German", fr: "Allemand" },
        hindi: { en: "Hindi", fr: "Hindi" },
        urdu: { en: "Urdu", fr: "Urdu" },
        marathi: { en: "Marathi", fr: "Marathi" },
        gujarati: { en: "Gujarati", fr: "Gujarati" },
        slovak: { en: "Slovak", fr: "Slovak" },
        turkish: { en: "Turkish", fr: "Turc" },
        pashto: { en: "Pashto", fr: "Pashto" },
        bengali: { en: "Bengali", fr: "Bengali" },
        punjabi: { en: "Punjabi", fr: "Punjabi" },
        slovenian: { en: "Slovenian", fr: "Slovène" },
        hungarian: { en: "Hungarian", fr: "Hongrois" },
        "other african languages": { en: "Other African Languages", fr: "Autres Langues Africaines" },
        "other asian languages": { en: "Other Asian Languages", fr: "Autres Langues Asiatiques" },
        kinyarwanda: { en: "Kinyarwanda", fr: "Kinyarwanda" },
        runyankore: { en: "Runyankore", fr: "Runyankore" },
        xitswa: { en: "Xitswa", fr: "Xitswa" },
        khoekhoe: { en: "Khoekhoe", fr: "Khoekhoe"},
        oshikwanyama: { en: "Oshikwanyama", fr: "Oshikwanyama"},
        oshindonga: { en: "Oshindonga", fr: "Oshindonga" },
        otjiherero: { en: "Otjiherero", fr: "Otjiherero" },
        rukwangali: { en: "Rukwangali", fr: "Rukwangali" },
        akuapem: { en: "Akuapem", fr: "Akuapem" },
        alur: { en: "Alur", fr: "Alur" },
        anil: { en: "Anil", fr: "Anil" },
        chishona: { en: "ChiShona", fr: "ChiShona" },
        cinyanja: { en: "CiNyanja", fr: "CiNyanja" },
        cinyungwe: { en: "Cinyungwe", fr: "Cinyungwe" },
        dagaare: { en: "Dagaare", fr: "Dagaare" },
        dagbani: { en: "Dagbani", fr: "Dagbani" },
        dangme: { en: "Dangme", fr: "Dangme" },
        ewe: { en: "Ewe", fr: "Ewe" },
        gikuyu: { en: "Gikuyu", fr: "Gikuyu"},
        kigiryama: { en: "KiGiryama", fr: "KiGiryama" },
        kirundi: { en: "Kirundi", fr: "Kirundi" },
        kunama: { en: "Kunama", fr: "Kunama" },
        likpakpaani: { en: "Likpakpaani", fr: "Likpakpaani" },
        likpakpaanl: { en: "Likpakpaanl", fr: "Likpakpaanl" },
        lingala: { en: "Lingala", fr: "Lingala" },
        lubukusu: { en: "Lubukusu", fr: "Lubukusu" },
        lulogoli: { en: "Lulogoli", fr: "Lulogoli" },
        pokomo: { en: "Pokomo", fr: "Pokomo" },
        bangla: { en: "Bangla", fr: "Bangla" },
        "chinese, simplified": { en: "Chinese, Simplified", fr: "Chinois simplifié" },
        "chinese, traditional": { en: "Chinese, Traditional", fr: "Chinois traditionnel" },
    },

    levels: {
        beginner: {
            en: "Beginner",
            fr: "Débutant",
        },
        easy: {
            en: "Easy",
            fr: "Facile",
        },
        average: {
            en: "Average",
            fr: "Intermédiaire",
        },
        advanced: {
            en: "Advanced",
            fr: "Avancé",
        },
        expert: {
            en: "Expert",
            fr: "Expert"
        }
    },

    menu: {
        books: {
            en: "Books",
            fr: "Livres",
        }
    },
    
    searchbar: {
        search: {
            en: "Search",
            fr: "Recherche"
        }
    },
    
    themes: {
        adventure: {
            en: "Adventure",
            fr: "Aventure",
        },
        animals: {
            en: "Animals",
            fr: "Animaux",
        },
        body: {
            en: "Body",
            fr: "Corps",
        },
        colours: {
            en: "Colours",
            fr: "Couleurs",
        },
        "family and friends": {
            en: "Family and Friends",
            fr: "Famille et amis",
        },
        "feelings and values": {
            en: "Feelings and Values",
            fr: "Sentiments et valeurs",
        },
        food: {
            en: "Food",
            fr: "Nourriture",
        },
        "games and sports": {
            en: "Games and Sports",
            fr: "Jeux et sports",
        },
        imagination: {
            en: "Imagination",
            fr: "Imagination",
        },
        nature: {
            en: "Nature",
            fr: "Nature",
        },
        numbers: {
            en: "Numbers",
            fr: "Chiffres",
        },
        places: {
            en: "Places",
            fr: "Lieu (endroit)",
        },
        "outer space": {
            en: "Outer Space",
            fr: "Espace",
        },
        school: {
            en: "School",
            fr: "École",
        },
        "other themes": {
            en: "Other Themes", 
            fr: "Autres thèmes",
        }
    },

    types: {
        fiction: {
            en: "Fiction",
            fr: "Fiction",
        },
        "non-fiction": {
            en: "Non-fiction",
            fr: "Non-fictif"
        },
        poetry: {
            en: "Poetry",
            fr: "Poésie",
        }
    }
};
